import { Button, Row } from "antd";
import { Link } from "react-router-dom";
import PageLayout from "../../components/layout/PageLayout/PageLayout";
import TableEvents from "../../components/tables/TableEvents/TableEvents";
import { useLazyFetchPaginatedEventsQuery } from "../../features/api/apiSlice";
import styles from "./PageAllEvents.module.scss";
import Br from "../../components/ui/Br";
import spacing from "../../components/ui/spacingConfig";
import { useCrudEvent } from "../../features/api/crud/hooks/useCrudEvent";

const PageEvents: React.FC = () => {
  // Fetch events
  const [fetchPaginatedEvents, { data, isFetching }] =
    useLazyFetchPaginatedEventsQuery();

  // Event: delete
  const { onDelete: onDeleteEvent, isDeleting: isDeletingEvent } = useCrudEvent(
    {
      fetchEvents: fetchPaginatedEvents,
    },
  );

  return (
    <PageLayout pageContainerClassName={styles.root}>
      <div className={styles.top}>
        <h1>Les Ã©vÃ©nements</h1>
        <Link type="primary" to="/events/new">
          <Button type="primary">CrÃ©er un nouvel Ã©vÃ©nement</Button>
        </Link>
      </div>
      <Br height={spacing.m} />
      <Row>
        <TableEvents
          eventsData={data}
          // eventsData={mockedEventsData}
          fetchData={fetchPaginatedEvents}
          isLoading={isFetching || isDeletingEvent}
          onDelete={onDeleteEvent}
        />
      </Row>
    </PageLayout>
  );
};

export default PageEvents;
